<div class="spinner-wrapper">
  <mat-spinner></mat-spinner>
  <div class="spinner-message" *ngIf="isFileUploading">{{'MANAGE-ELEARNING.DETAIL.FILE-UPLOADING' | translate}}</div>
</div>
